import { useMemo, useState } from "react";
import BWStatusFilter from "./BWStatusFilter";
import CategoryFilter from "./CategoryFilter";
import CommonGrid from "../CommonGrid/CommonGrid";
import {
  getHelpNeededGridColumns,
  helpNeededGridFilters,
  helpNeededGridGlobalFilterFields,
} from "./gridConfig";
import ExportSelectedRows from "../../ExportCSV";
import "./ModuleGrids.scss";

const HelpNeededGrid = ({
  data = [],
  mode = "min",
  dataKey = "AWMProjectID",
  emptyMessage = "No help needed data found.",
  tableProps = {},
  rows = 20,
  paginator,
  onNavigate,
  title = ""
}) => {
  const bwOptions = [
    { label: "On Track", value: "onTrack" },
    { label: "At Risk", value: "atRisk" },
    { label: "Off Track", value: "offTrack" },
  ];
  const [bwValue, setBwValue] = useState([]);
  const [categoryValue, setCategoryValue] = useState([]);
  
  const columns = useMemo(() => getHelpNeededGridColumns(mode), [mode]);

  // Helper to get B:W status from value
  const getBWStatus = (value) => {
    if (value <= 0) return "offTrack";
    if (value > 0 && value <= 0.3) return "atRisk";
    if (value > 0.3) return "onTrack";
    return null;
  };

  // Filter data based on selected B:W and Category values
  let filteredData = data;
  if (mode === "max" && bwValue.length > 0) {
    filteredData = filteredData.filter((row) => bwValue.includes(getBWStatus(row.BufferToWork)));
  }
  if (mode === "max" && categoryValue.length > 0) {
    filteredData = filteredData.filter((row) => categoryValue.includes(row.Category));
  }

  // Extract unique categories from data
  const categoryOptions = Array.from(
    new Set(data.map((item) => item.Category).filter(Boolean))
  ).map((item) => ({
    label: item,
    value: item,
  }));

  return (
    <>
      {mode === "max" && (
        <div className="help-needed-grid-filters">
          <ExportSelectedRows
            allData={filteredData}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)}
            filename={`${title}_Records`}
          />
          <BWStatusFilter bwOptions={bwOptions} value={bwValue} setValue={setBwValue} />
          <CategoryFilter value={categoryValue} setValue={setCategoryValue} getAPI={false} categoryOptions={categoryOptions} />
        </div>
      )}
      <CommonGrid
        data={filteredData}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? helpNeededGridFilters : undefined}
        globalFilterFields={mode === "max" ? helpNeededGridGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        showACPFilter={true}
      />
    </>
  );
};

export default HelpNeededGrid;
